module.exports = __webpack_public_path__ + "static/img/Doomyoga-logo.fae3772.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/Doomyoga-logo.png
// module id = g6Ko
// module chunks = 0